import React from "react";

/* eslint-disable max-len */
export default function SlidePlayButton() {
	return (
		<svg version="1.1" id="레이어_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px"
			y="0px" viewBox="0 0 198.2 80.56" enableBackground="new 0 0 198.2 80.56" xmlSpace="preserve">
			<g>
				<g>
					<path fill="#FFFFFF" d="M159.94,63.61H37.14c-14.38,0-26.04-11.66-26.04-26.04v0c0-14.38,11.66-26.04,26.04-26.04h122.8
			c14.38,0,26.04,11.66,26.04,26.04v0C185.98,51.95,174.32,63.61,159.94,63.61z"/>
					<path fill="none" stroke="#6D6D6D" strokeWidth="3" strokeMiterlimit="10" d="M159.94,63.61H37.14
			c-14.38,0-26.04-11.66-26.04-26.04v0c0-14.38,11.66-26.04,26.04-26.04h122.8c14.38,0,26.04,11.66,26.04,26.04v0
			C185.98,51.95,174.32,63.61,159.94,63.61z"/>
				</g>
			</g>
			<g>
				<path fill="#6D6D6D" d="M104.76,25.93c2.61,0,4.52,0.53,5.71,1.58s1.79,2.53,1.79,4.41c0,1.12-0.25,2.17-0.74,3.14
		c-0.5,0.97-1.32,1.76-2.48,2.37s-2.73,0.91-4.7,0.91h-2.16v7.59h-3.02V25.93H104.76z M104.54,28.48h-2.35v7.31h1.82
		c1.7,0,2.98-0.28,3.85-0.85c0.87-0.57,1.3-1.54,1.3-2.9c0-1.19-0.37-2.09-1.12-2.67C107.29,28.77,106.13,28.48,104.54,28.48z"/>
				<path fill="#6D6D6D" d="M118.93,45.92h-2.97V24.64h2.97V45.92z" />
				<path fill="#6D6D6D" d="M129.43,30.55c1.89,0,3.3,0.42,4.24,1.25c0.94,0.83,1.41,2.13,1.41,3.91v10.22h-2.1l-0.59-2.1h-0.11
		c-0.65,0.82-1.34,1.42-2.06,1.81c-0.72,0.38-1.71,0.57-2.98,0.57c-1.36,0-2.49-0.37-3.39-1.11c-0.9-0.74-1.34-1.89-1.34-3.46
		c0-1.55,0.58-2.72,1.75-3.51c1.17-0.79,2.94-1.23,5.33-1.3l2.58-0.08V35.9c0-1.1-0.25-1.88-0.76-2.34
		c-0.5-0.46-1.21-0.69-2.13-0.69c-0.77,0-1.5,0.11-2.21,0.34c-0.71,0.22-1.39,0.5-2.04,0.81l-0.95-2.16
		c0.71-0.37,1.53-0.69,2.45-0.94C127.46,30.67,128.42,30.55,129.43,30.55z M132.15,38.67l-2.02,0.06c-1.72,0.08-2.91,0.36-3.57,0.87
		c-0.66,0.5-0.99,1.2-0.99,2.07c0,0.78,0.23,1.35,0.7,1.71s1.07,0.53,1.82,0.53c1.16,0,2.12-0.33,2.9-0.98
		c0.77-0.65,1.16-1.63,1.16-2.94V38.67z"/>
				<path fill="#6D6D6D" d="M137.36,30.83h3.19l3.14,8.57c0.24,0.65,0.46,1.28,0.64,1.88c0.19,0.6,0.32,1.2,0.39,1.79h0.11
		c0.09-0.48,0.24-1.05,0.43-1.71c0.2-0.65,0.42-1.32,0.66-1.99l2.97-8.54h3.19l-6.47,17.14c-0.54,1.46-1.26,2.6-2.17,3.43
		c-0.91,0.83-2.09,1.25-3.54,1.25c-0.47,0-0.87-0.02-1.2-0.07c-0.34-0.05-0.63-0.1-0.87-0.15v-2.35c0.19,0.04,0.43,0.08,0.73,0.11
		c0.3,0.04,0.61,0.06,0.92,0.06c0.86,0,1.55-0.25,2.07-0.74c0.52-0.5,0.93-1.14,1.23-1.95l0.62-1.62L137.36,30.83z"/>
			</g>
			<g>
				<path fill="none" stroke="#6D6D6D" strokeWidth="2.9075" strokeMiterlimit="10" d="M77.19,45.71H57.24c-1,0-1.81-0.81-1.81-1.81
		V23.95c0-1,0.81-1.81,1.81-1.81h19.95c1,0,1.81,0.81,1.81,1.81V43.9C78.99,44.9,78.18,45.71,77.19,45.71z"/>
				<path fill="none" stroke="#6D6D6D" strokeWidth="2.9075" strokeMiterlimit="10" d="M72.59,51.5h-21.8
		c-0.98,0-1.77-0.79-1.77-1.77v-21.8"/>
				<polygon fill="#6D6D6D" points="72.73,33.92 63.6,27.33 63.6,40.52 	" />
			</g>
		</svg>
	);
}
